export default {
  getHead: () => {
    return [{ name: '대상 사업장명' }, { name: '피평가자' }, { name: '평가일' }, { name: '소속명' }, { name: '부서명' }, { name: '작성자' }]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name       // 대상 사업장명
        case 1: return func.getContent(value).inputA_5       // 피평가자
        case 2: return func.getContent(value).inputA_6       // 평가일
        case 3: return func.getContent(value).stdInfo.department  // 소속명
        case 4: return func.getContent(value).stdInfo.com_name    // 부서명
        case 5: return value.user ? value.user.name : value.author.name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    return []
  },
}
